<template>
    <pagination title="POD & Delivery Confirmations" :response="response" :entities="pods" :hasEntities="pods !== null" :checkSize="false" header-colour-class="bg-transparent" :show-title-bar="false">
        <template v-slot:additional-buttons>
            <slot name="additional-buttons"></slot>
        </template>
        <template v-slot:headers>
            <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-6">Name
            </th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold">File</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold">Status</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold">Actions</th>

        </template>
        <template v-slot:items>
            <tr v-for="item in pods">
                <td class="whitespace-normal pl-4 pr-3 text-sm font-medium sm:pl-6">
                    <div>
                        {{item.entity.properties.get('name')}}
                    </div>
                </td>
                <td class="whitespace-normal pl-4 pr-3 text-sm font-medium">
                    <div>
                        <download-pdf-icon-with-link :url="item.entity.properties.get('file')"></download-pdf-icon-with-link>
                    </div>
                </td>
                <td class="whitespace-normal pl-4 pr-3 text-sm font-medium">
                    <div>
                        {{item.entity.properties.get('status')}}
                    </div>
                </td>
                <td class="whitespace-normal pl-4 pr-3 text-sm font-medium">
                    <form-action class="mb-2" v-if="item.entity.actions.get('link-invoice')"
                                 :action="item.entity.actions.get('link-invoice')"
                                 actionKey="link-invoice"
                                 :onSuccessPath="$router.currentRoute.fullPath"
                                 @success="$emit('success')"
                                 :redirect-on-success="false"
                                 title="Link"
                    ></form-action>
                    <confirmation-action class="mb-2" v-if="item.entity.actions.get('approve-pod')"
                                         :action="item.entity.actions.get('approve-pod')"
                                         actionKey="approve-pod"
                                         :onSuccessPath="$router.currentRoute.fullPath"
                                         @success="$emit('success')"
                                         :redirect-on-success="false"
                                         title="Approve">
                    </confirmation-action>
                </td>
            </tr>
        </template>
    </pagination>
</template>
<script>
import Pagination from "@/v3/components/pagination/Pagination.vue";
import DownloadPdfIconWithLink from "@/v3/components/modals/DownloadPdfIconWithLink.vue";
import ConfirmationAction from "@/v3/components/forms/ConfirmationAction.vue";
import FormAction from "@/v3/components/forms/FormAction.vue";
export default {
  name: 'OrderPods',
    data(){
      return {
        Pagination,
          DownloadPdfIconWithLink
      }
    },
    components: {
        FormAction,
        ConfirmationAction,
        Pagination,
        DownloadPdfIconWithLink
    },
  props: {
        pods: {
            type: Object|Array,
            default: null
        },
      response: {
        type: Object,
          default: null
      }
  },
    methods:{
        attachmentUrl(url){
            if(!url.includes('/')){
                return process.env.VUE_APP_API_URL +'/api/files/attachments/' + url;
            }
            if(url.includes('public')){
                return process.env.VUE_APP_API_URL + '/' + url.replace('public', 'storage');
            }
            return process.env.VUE_APP_API_URL +'/api/files/' + url;
        },
    }
}
</script>
